import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

import { OptIn } from '../models';

export interface OptInApi {
    items: OptIn[];
    total_count: number;
}

@Injectable({
    providedIn: 'root'
})
export class OptInService {
    private _optInsRoute = '/api/opt-ins/';
    private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    public optInBeingViewed: any = {};

    constructor(
        private httpClient: HttpClient,
    ) { }


    setOptInToBeViewed(_optIn: any) {
        this.optInBeingViewed = _optIn;
    }


    getOptInToBeViewed() {
        return this.optInBeingViewed;
    }


    get(): Observable<OptIn[]> {
        return this.httpClient.get<OptIn[]>(this._optInsRoute);
    }


    getById(optInId: string): Observable<OptIn> {
        return this.httpClient.get<OptIn>(this._optInsRoute + optInId);
    }


    getByUser(userId: string): Observable<OptIn> {
        return this.httpClient.get<OptIn>(this._optInsRoute + 'user/' + userId);
    }


    getByEmail(email: string): Observable<OptIn> {
        return this.httpClient.get<OptIn>(this._optInsRoute + 'email/' + email);
    }


    create(optIn: OptIn): Observable<OptIn> {
        return this.httpClient.post<OptIn>(this._optInsRoute, JSON.stringify(optIn), this.headerOptions);
    }


    selectAllSearch(searchTerms: OptIn): Observable<OptInApi> {
        searchTerms['selectAll'] = true;
        return this.httpClient.post<OptInApi>(this._optInsRoute + 'dataSourceSearch', JSON.stringify(searchTerms), this.headerOptions);
    }


    getCustomDatasource(searchParams, sortField, sortDirection, pageNumber: number, pageSize: number): Observable<OptInApi> {
        searchParams['selectAll'] = false;
        searchParams.sortField = (sortField && sortField !== '') ? sortField : 'createdAt';
        searchParams.sortOrder = (sortDirection && sortDirection !== '') ? sortDirection : 'desc';
        searchParams.pageNumber = (pageNumber && pageNumber !== undefined) ? pageNumber : 0;
        searchParams.pageSize = (pageSize && pageSize !== undefined) ? pageSize : 10;

        return this.httpClient.post<OptInApi>(this._optInsRoute + 'dataSourceSearch', JSON.stringify(searchParams), this.headerOptions);
    }


    markDelete(_id: string): Observable<any> {
        return this.httpClient.put(this._optInsRoute + 'mark-deleted/' + _id, this.headerOptions);
    }
}
